export default "__VITE_ASSET__B6Q6RUmI__"